import juice from 'juice';
import jsPDF from 'jspdf';
import toPx from 'unit-to-px';

import html2canvas from 'html2canvas';
import { POWERED_BY_MONDAY } from '../constants/assets';
import SIZES from '../constants/modal-sizes';
import { getDocumentStyles } from '../utils/styles-utils';
import { openMondayModal } from './monday-service';
import { getCroppedCanvas, imageDataFromUrl } from './images-service';
import { pdf } from '../constants/files';
import { SHARE_VIEW } from '../constants/view-types';

const getPoweredByMondayElement = () => {
  const div = document.createElement('div');
  div.setAttribute('class', 'powered-by-link');
  div.innerHTML = `<a href="https://monday.com?utm_source=Product&utm_campaign=CRMQuote" target="_blank"><img src="${POWERED_BY_MONDAY.url}" height="${POWERED_BY_MONDAY.height}" alt="Powered by monday.com" class="powered-by-image" /></a>`;
  return div;
};

export const buildOrderToShare = (element, removeBrand) => {
  const html = element.cloneNode(true);
  const poweredByElement = getPoweredByMondayElement();
  html.setAttribute('class', 'preview-template');
  if(removeBrand === false){
    html.appendChild(poweredByElement);
  }

  const orderHTML = `<style>${getDocumentStyles()}</style>${html.outerHTML}`;
  const result = juice(orderHTML);
  return result;
};

export const openShareOrderModal = (orderLinkId) => {
  openMondayModal({
    url: process.env.REACT_APP_BILLING_APP_URL,
    urlParams: { view: SHARE_VIEW, id: orderLinkId },
    width: SIZES.SHARE_MODAL.width,
    height: SIZES.SHARE_MODAL.height,
  });
};

export const saveOrderToPDF = async (element, removeBrand) => {
  const doc = jsPDF({ unit: 'cm' });
  window.scrollTo(0, 0);
  const pdfWidthPx = toPx(`${pdf.A4.content.width}cm`);
  const pdfHeightPx = toPx(`${pdf.A4.content.height}cm`);

  let pdfPagesOffsets = [0];
  let lastDistanceFromTop = 0;

  const baseTopCoordinate = element.getBoundingClientRect().top;
  const rowNodes =[...element.getElementsByClassName('pdf-row')];
  const rowNodesLength = rowNodes.length;

  const updateDistancesFromTop = (child, last = false) => {
    const currBottomCoordinate = child.getBoundingClientRect().bottom;
    const calcDistanceFromTop = Math.ceil(currBottomCoordinate - baseTopCoordinate);

    if(calcDistanceFromTop >= (pdfPagesOffsets.length - 1) * pdfHeightPx + pdfHeightPx){
      pdfPagesOffsets.push(lastDistanceFromTop);
    }
    if(last){
      pdfPagesOffsets.push(calcDistanceFromTop);
    }
    lastDistanceFromTop = calcDistanceFromTop;
  }

  try {
    rowNodes.forEach((node, index) => {
      if(!node) return;
      const isLastElement = rowNodesLength - 1 === index;
      updateDistancesFromTop(node, isLastElement);
    });

    const canvas = await html2canvas(element, {
      useCORS: true,
      removeContainer: true,
      scrollY: 0,
      width: element.getBoundingClientRect().width,
      scale: 1,
    });

    const totalPdfPages = pdfPagesOffsets.length-1;
    const poweredByImageData = await imageDataFromUrl(pdf.A4.poweredByMonday.image);

    for (var i = 0; i < totalPdfPages; i++) {
      const isLastPage = totalPdfPages - 1 === i;
      const startPoint = {
        x: 0,
        y: pdfPagesOffsets[i]
      };

      const endPoint = {
        x: pdfWidthPx,
        y: pdfPagesOffsets[i+1]
      };

      const croppedCanvas = getCroppedCanvas(canvas, startPoint, endPoint);
      doc.addImage(croppedCanvas.toDataURL(`image/jpeg`), 'JPEG', pdf.A4.margins.y, pdf.A4.margins.y);

      if(removeBrand === false){
        doc.addImage(poweredByImageData, 'JPEG', pdf.A4.poweredByMonday.x, pdf.A4.poweredByMonday.y);
      }
      // If it is not the last page add another one
      !isLastPage && doc.addPage();
    }
    doc.save('quote.pdf');
  } catch (e) {
    throw e;
  }
};
